import React, { useEffect, useState } from "react";
import styles from "./page5.module.scss";
import image from "../../images/building.svg";
import dots from "../../images/dots.svg";
import dots2 from "../../images/dots2.svg";
import colorImage from "../../images/buildingcolorimage.svg"
import video from "../../images/buildingvideo.mp4"

export default function Page5() {
  const [currentImage, setCurrentImage] = useState(image);
  useEffect(() => {
    // Set a timer to change the image every second
    const interval = setInterval(() => {
      setCurrentImage((prevImage) => (prevImage === image ? colorImage : image));
    }, 1000);

    // Clear the interval when the component unmounts
    return () => clearInterval(interval);
  }, []);

  return (
    <div className={styles.mainwrapper}>
      <div className={styles.left}>
        {/* <img className={styles.leftimage} src={currentImage} alt="building" /> */}
        <video autoPlay={true} loop muted className={styles.leftimage}>
          <source
            src="https://firstock-common.s3.ap-south-1.amazonaws.com/projects/connect/landingpage1.mp4"
            type="video/mp4"
          />
        </video>
      </div>
      <div className={styles.right}>
        <div className={styles.dotscontainer}>
          <img className={styles.dots} src={dots} alt="dots" />
        </div>
        <div className={styles.textContent}>
          <div className={styles.heading}>
            <p>Bring your ideas to life with Firstock Connect</p>
          </div>
          <div className={styles.para}>
            <p>
              With Firstock Connect, you can create a comprehensive trading
              platform that includes features such as real-time order execution,
              portfolio management, live market data streaming, and other
              capabilities.
            </p>
          </div>
          <div>
            <img className={styles.dots2} src={dots2} alt="dots" />
          </div>
        </div>
      </div>
    </div>
  );
}
